import { ArrowLeftRight, Check, X } from 'lucide-react';
import { useMemo, useState } from 'react';
import { formatMoney } from '../utils/board.js';

function PropertyChecks({ title, ids, game, selected, onToggle }) {
  return (
    <fieldset className="trade-properties">
      <legend>{title}</legend>
      {ids.length === 0 && <span>Нет объектов для передачи</span>}
      {ids.map((id) => (
        <label key={id}>
          <input type="checkbox" checked={selected.includes(id)} onChange={() => onToggle(id)} />
          <span>{game.board[id].name}</span>
          {game.properties.find((item) => item.id === id)?.mortgaged && <small>ипотека</small>}
        </label>
      ))}
    </fieldset>
  );
}

export function TradeModal({ open, onClose, game, viewerId, action }) {
  const me = game.players.find((player) => player.id === viewerId);
  const others = useMemo(() => game.players.filter((player) => !player.bankrupt && player.id !== viewerId), [game.players, viewerId]);
  const [toPlayerId, setToPlayerId] = useState(others[0]?.id ?? '');
  const [offeredMoney, setOfferedMoney] = useState(0);
  const [requestedMoney, setRequestedMoney] = useState(0);
  const [offeredPropertyIds, setOfferedPropertyIds] = useState([]);
  const [requestedPropertyIds, setRequestedPropertyIds] = useState([]);
  const [busy, setBusy] = useState(false);
  const other = others.find((player) => player.id === toPlayerId) ?? others[0];

  if (!open) return null;

  const toggle = (setter) => (id) => setter((values) => (values.includes(id) ? values.filter((value) => value !== id) : [...values, id]));
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      await action('trade:create', { toPlayerId: other.id, offeredMoney: Number(offeredMoney), requestedMoney: Number(requestedMoney), offeredPropertyIds, requestedPropertyIds });
      setOfferedPropertyIds([]);
      setRequestedPropertyIds([]);
      onClose();
    } catch {
      // Причина отображается глобально.
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <form className="trade-modal" role="dialog" aria-modal="true" aria-labelledby="trade-title" onSubmit={submit}>
        <header className="drawer__header"><div><span>Обмен без посредников</span><h2 id="trade-title">Предложить сделку</h2></div><button type="button" onClick={onClose} aria-label="Назад"><X /></button></header>
        {others.length === 0 ? <p className="empty-state">Нет доступных игроков для сделки.</p> : (
          <>
            <label className="field"><span>Партнёр</span><select value={other?.id} onChange={(event) => { setToPlayerId(event.target.value); setRequestedPropertyIds([]); }}>{others.map((player) => <option key={player.id} value={player.id}>{player.name} · {formatMoney(player.money)}</option>)}</select></label>
            <div className="trade-columns">
              <section><h3>МОЁ · я отдаю</h3><label className="field"><span>Деньги</span><input type="number" min="0" max={me.money} step="1" value={offeredMoney} onChange={(event) => setOfferedMoney(event.target.value)} /></label><PropertyChecks title="Имущество" ids={me.properties} game={game} selected={offeredPropertyIds} onToggle={toggle(setOfferedPropertyIds)} /></section>
              <ArrowLeftRight className="trade-arrow" />
              <section><h3>ДРУГОЙ ИГРОК · {other?.name}</h3><label className="field"><span>Деньги</span><input type="number" min="0" max={other?.money ?? 0} step="1" value={requestedMoney} onChange={(event) => setRequestedMoney(event.target.value)} /></label><PropertyChecks title="Имущество" ids={other?.properties ?? []} game={game} selected={requestedPropertyIds} onToggle={toggle(setRequestedPropertyIds)} /></section>
            </div>
            <button className="button button--primary button--wide" type="submit" disabled={busy}><Check size={18} />{busy ? 'Отправляем…' : 'Отправить предложение'}</button>
          </>
        )}
      </form>
    </div>
  );
}
